/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SpecificationsInputs */

const en_specifications = /** @type {(inputs: SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specifications`)
};

const es_specifications = /** @type {(inputs: SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificaciones`)
};

const fr_specifications = /** @type {(inputs: SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spécifications`)
};

const de_specifications = /** @type {(inputs: SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spezifikationen`)
};

const ja_specifications = /** @type {(inputs: SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仕様`)
};

const zh_specifications = /** @type {(inputs: SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`规格`)
};

const ar_specifications = /** @type {(inputs: SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المواصفات`)
};

const id_specifications = /** @type {(inputs: SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spesifikasi`)
};

const it_specifications = /** @type {(inputs: SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specifiche`)
};

const ru_specifications = /** @type {(inputs: SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Характеристики`)
};

const pt_specifications = /** @type {(inputs: SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificações`)
};

const ko_specifications = /** @type {(inputs: SpecificationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사양`)
};

/**
* | output |
* | --- |
* | "Specifications" |
*
* @param {SpecificationsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const specifications = /** @type {((inputs?: SpecificationsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SpecificationsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_specifications(inputs)
	if (locale === "es") return es_specifications(inputs)
	if (locale === "fr") return fr_specifications(inputs)
	if (locale === "de") return de_specifications(inputs)
	if (locale === "ja") return ja_specifications(inputs)
	if (locale === "zh") return zh_specifications(inputs)
	if (locale === "ar") return ar_specifications(inputs)
	if (locale === "id") return id_specifications(inputs)
	if (locale === "it") return it_specifications(inputs)
	if (locale === "ru") return ru_specifications(inputs)
	if (locale === "pt") return pt_specifications(inputs)
	return ko_specifications(inputs)
});